import { IconPack, library } from '@fortawesome/fontawesome-svg-core'; // Core SVG
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'; // Integration
import {
  faArrowLeft,
  faEye,
  faEyeSlash,
  faLock,
  faQuestion,
  faUser,
  faCaretUp,
  faCaretDown
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faUser as unknown as IconPack,
  faQuestion as unknown as IconPack,
  faArrowLeft as unknown as IconPack,
  faEyeSlash as unknown as IconPack,
  faEye as unknown as IconPack,
  faLock as unknown as IconPack,
  faCaretUp as unknown as IconPack,
  faCaretDown as unknown as IconPack
);

const coreLoginPanelIcons = {
  coreLoginPanelIconQuestion: {
    component: FontAwesomeIcon,
    props: {
      icon: ['fas', 'question']
    }
  },
  coreLoginPanelIconPerson: {
    component: FontAwesomeIcon,
    props: {
      icon: ['fas', 'user']
    }
  },
  coreLoginPanelIconLock: {
    component: FontAwesomeIcon,
    props: {
      icon: ['fas', 'lock']
    }
  },
  coreLoginPanelIconEye: {
    component: FontAwesomeIcon,
    props: {
      icon: ['fas', 'eye']
    }
  },
  coreLoginPanelIconEyeSlash: {
    component: FontAwesomeIcon,
    props: {
      icon: ['fas', 'eye-slash']
    }
  },
  coreLoginPanelIconArrowLeft: {
    component: FontAwesomeIcon,
    props: {
      icon: ['fas', 'arrow-left']
    }
  },
  caretDown: {
    component: FontAwesomeIcon,
    props: {
      icon: ['fas', 'caret-down']
    }
  },
  caretUp: {
    component: FontAwesomeIcon,
    props: {
      icon: ['fas', 'caret-up']
    }
  }
};

// eslint-disable-next-line import/prefer-default-export
export { coreLoginPanelIcons };
